import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-[200] overflow-auto vue-modal-background tw at-update-rate-group",
  style: {
    "z-index": "100"
  }
};
const _hoisted_2 = {
  key: 1,
  class: "px-4"
};
const _hoisted_3 = {
  class: "flex justify-between px-4 py-4"
};
const _hoisted_4 = {
  class: "btn-group pull-right dropdown pt-2"
};
const _hoisted_5 = {
  class: "dropdown-menu"
};
const _hoisted_6 = {
  class: "flex py-2 px-4"
};
const _hoisted_7 = {
  key: 0,
  class: "w-4/12 pl-2"
};
const _hoisted_8 = {
  class: "px-4"
};
const _hoisted_9 = {
  class: "flex justify-between"
};
const _hoisted_10 = {
  class: "w-6/12 pr-2"
};
const _hoisted_11 = {
  class: "w-6/12 pl-2"
};
const _hoisted_12 = {
  class: "text-base"
};
const _hoisted_13 = {
  class: "w-full"
};
const _hoisted_14 = {
  class: "grid grid-cols-2 gap-x-4"
};
const _hoisted_15 = {
  class: ""
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  class: ""
};
const _hoisted_18 = {
  class: "flex pt-2"
};
const _hoisted_19 = {
  class: "py-2"
};
const _hoisted_20 = {
  class: "flex"
};
const _hoisted_21 = {
  class: "w-full"
};
const _hoisted_22 = {
  class: "py-1"
};
const _hoisted_23 = {
  src: "/img/qb16x16.png"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "flex justify-between py-4"
};
const _hoisted_26 = {
  class: "flex"
};
const _hoisted_27 = {
  class: "pr-2"
};
import { reactive, onMounted, ref, watch } from "vue";
import axios from "axios";
import CodeService from "@/services/CodeService";
import Loader from "@/components/Loader.vue";
import MainHeader from "@/components/MainHeader.vue";
import ClientMatterSearch from "@/components/ClientMatterSearch.vue";
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTooltip from "@/components/LlTooltip.vue";
import LlTextField from '@/components/LlTextField.vue';
import { useExpenseStore } from "@/services/useExpenseStore";
import useClientMatterStore from "@/services/useClientMatterStore";
import { useSnackbarHandler } from "@/composables/useSnackbarHandler";
import fileUtilities from "@/services/fileUtilities.js";
import imageUtilities from "@/services/imageUtilities.js";
import MultipleAttachmentPreview from "../../components/MultipleAttachmentPreview.vue";
import { attachmentsToFileSelector, acceptedFileTypes, truncateFileName, generateRandomID } from "@/utils/attachmentsToFileSelector.js";
import RouteService from "@/services/RouteService";
export default {
  __name: 'QBOexpense',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    userService: {
      type: Object,
      required: false
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    http: {
      type: Function,
      required: true
    },
    expenseId: {
      type: String,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    }
  },
  emits: ["reload", "cancel"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const expenseStore = useExpenseStore();
    const clientMatterStore = useClientMatterStore();
    const {
      handleError
    } = useSnackbarHandler();
    const state = reactive({
      loading: true,
      error: null,
      readonly: true,
      // What <ClientMatterSearch> reads and writes: lean option records, which it overwrites
      // from its own lookups. state.expense.client / .matter stay this form's own copies.
      cm: {
        client: null,
        matter: null
      },
      cmQueryFilter: null,
      masks: {
        input: "MM-DD-YYYY"
      },
      fileSelector: [],
      showUploadModal: false,
      fileToUpload: [],
      customFlag: false,
      okToClearDescription: false,
      expense: {
        date: new Date(),
        amount: 0,
        description: "",
        customFlag: false,
        codeId: undefined,
        account: undefined,
        customFlag: false
      },
      saving: false,
      dropped: false,
      selectedFileIndex: 0,
      showQboExpense: false
    });
    const fileInput = ref(null);
    const confirmationDialog = ref(null);
    function triggerFileInput() {
      const inputElement = fileInput.value.$el.querySelector('input[type="file"]');
      if (inputElement) {
        inputElement.click();
      } else {
        console.error("File input not found");
      }
    }
    onMounted(async () => {
      state.loading = true;
      state.routeService = new RouteService(props);
      const codeService = new CodeService(props.leanLawApi, props.http, props.leanLawAuth);
      const [me, codes, users] = await Promise.all([props.userService.getMe(), codeService.expenseCodes(), props.userService.list()]);
      state.me = me;
      state.codes = codes;
      state.accounts = users;
      const enableFlags = me.role === "operator" || me.permissions?.matters?.autoAssign;
      state.cmQueryFilter = {
        scopeAccount: null,
        involved: !enableFlags,
        originating: false,
        reviewer: false,
        primary: false,
        archived: false
      };
      const expense = await expenseStore.getExpense({
        id: props.stateParams.expenseId ? props.stateParams.expenseId : props.expenseId
      });
      state.expense = expense;
      state.expense.account = expense.account;
      if (expense.code?.id) {
        state.expense.code = state.codes.find(code => code.id === expense.code.id);
      }
      state.fileSelector = attachmentsToFileSelector(state.expense.attachments);
      state.hasMatter = !!expense.matter;
      state.readonly = !!expense.billed || !me.permissions?.expenses?.create;
      state.requireExpenseUser = me.company.settings.requireExpenseUser;
      state.cm.client = expense.client || null;
      state.cm.matter = expense.matter || null;
      await syncClient(state.cm.client?.id);
      state.loading = false;
    });
    const confirmDeleteAttachment = () => {
      if (state.deleteExistingAttachmentClicked) {
        deleteExistingAttachment(state.attachmentToDelete);
        state.deleteExistingAttachmentClicked = false;
        return;
      }
      state.showUploadModal = true;
      state.attachmentToDelete = {};
    };
    let requestedClientId = null;
    async function syncClient(clientId) {
      if (!clientId) {
        requestedClientId = null;
        state.expense.client = null;
        return;
      }
      if (clientId === requestedClientId) return;
      requestedClientId = clientId;
      let client;
      try {
        client = await clientMatterStore.getClientById(clientId, true);
      } catch (error) {
        // Only act if this is still the selection: a rejection for a client the user has
        // already moved off would otherwise wipe the good one they can see.
        if (state.cm.client?.id !== clientId) return;
        // Keeping the previous client would let save() post it while the dropdown shows the
        // new one. Drop both copies so the selection is visibly gone.
        requestedClientId = null;
        state.expense.client = null;
        state.cm.client = null;
        handleError(error);
        return;
      }
      if (state.cm.client?.id !== clientId) return;
      state.expense.client = client;
    }

    /**
     * The matter needs no enrichment: save() narrows it to { id } and validation is the only
     * other reader. Snapshot the id rather than sharing the picker's record, which it replaces
     * wholesale on every lookup.
     */
    function syncMatter(matterId) {
      state.expense.matter = matterId ? {
        id: matterId
      } : null;
    }

    // Watching the ids rather than the objects keeps <ClientMatterSearch>'s own re-assignment of
    // the same selection from triggering a redundant fetch, and catches the assignments it makes
    // without emitting (matching a seeded selection to an option, auto-selecting a lone matter).
    watch(() => state.cm.client?.id, syncClient);
    watch(() => state.cm.matter?.id, syncMatter);
    const checkDescription = () => {
      if (!state.expense.description || state.okToClearDescription) {
        state.expense.description = state.expense.code.label;
      }
    };
    function back(reload, updated) {
      if (props.stateParams.expenseId) {
        state.routeService.go("^", {}, {
          reload: true
        });
        return;
      }
      if (!reload) {
        emits("cancel");
        return;
      }
      emits("reload", updated);
    }
    const deleteExpense = () => {
      bootbox.confirm("Are you sure you don't want to bill this expense to a client?", result => {
        if (result) {
          expenseStore.deleteExpense({
            id: state.expense.id
          }).then(() => {
            back(true, {
              ...state.expense,
              deleted: true
            });
          });
        }
      });
    };
    const quickbooks = () => {
      window.open(state.expense.accounting.href, "_blank");
    };
    const markAsBilled = () => {
      bootbox.confirm("Are you sure you want to mark this expenses as billed? It won't be available for invoicing afterwards.", result => {
        if (result) {
          state.saving = true;
          expenseStore.updateExpense({
            id: state.expense.id,
            body: {
              billed: true
            }
          });
          props.alerts.success("Expense was marked as billed");
          back(true, {
            ...state.expense,
            billed: true
          });
          state.saving = false;
        }
      });
    };
    const save = async () => {
      if (state.requireExpenseUser && state.expense.account === undefined) {
        return props.alerts.error("Please select a User");
      }
      if (!state.expense.description) {
        return props.alerts.error("Please enter an invoice description");
      }
      if (!state.expense.amount) {
        return props.alerts.error("Please enter an amount");
      }
      if (!state.expense.date) {
        return props.alerts.error("Please enter an Date");
      }
      if (!state.expense.matter || !state.expense.matter.id) {
        return props.alerts.error("Please select a " + state.me.terms.matter);
      }
      if (state.expense.date) {
        state.expense.date = new Date(state.expense.date).toNetworkDate();
      }
      if (!state.expense.account) {
        // necessary to remove an account if one was selected before update
        state.expense.account = {};
      }
      const {
        client,
        matter
      } = state.expense;
      const body = {
        ...state.expense,
        client: client ? {
          id: client.id
        } : undefined,
        matter: matter ? {
          id: matter.id
        } : undefined
      };
      state.saving = true;
      expenseStore.updateExpense({
        id: state.expense.id,
        body
      });
      await uploadAttachment(state.expense.id);
      back(true, {
        ...state.expense,
        updated: true
      });
      state.saving = false;
    };
    const onDrop = async event => {
      const files = event.dataTransfer.files;
      if (!files.length) return;
      state.fileToUpload = state.fileToUpload.concat([...files]);
      await processFiles(state.fileToUpload);
    };
    const selectAttachment = async () => {
      if (!state.fileToUpload.length) return;
      const files = state.fileToUpload;
      await processFiles(files);
    };
    const processFiles = async files => {
      await Promise.all(files.map(async selectedFile => {
        selectedFile.fileType = selectedFile?.type?.toLowerCase();
        selectedFile.id = generateRandomID();
        selectedFile.fileName = selectedFile.name;
        if (selectedFile.fileName.length > 100) {
          props.alerts.warning("File name is too long, it will be truncated");
          selectedFile.fileName = truncateFileName(selectedFile.fileName, 100);
        }
        if (acceptedFileTypes.indexOf(selectedFile?.type) === -1) {
          props.alerts.error("Unsupported file type");
          state.fileToUpload = [];
          state.dropped = true;
        } else if (selectedFile.size > 20000001) {
          props.alerts.error("Unsupported file size");
          state.fileToUpload = [];
          state.dropped = true;
        } else {
          if (selectedFile.fileType.indexOf("image") > -1 && selectedFile.fileType.indexOf("tiff") === -1) {
            selectedFile.src = await imageUtilities.createPreviewImage(selectedFile);
          } else {
            selectedFile.src = await fileUtilities.fileToBase64(selectedFile);
          }
        }
      }));
      if (!state.dropped) {
        state.showUploadModal = false;
        state.showAttachmentPreview = true;
        state.selectedFileIndex = state.fileSelector.length;
        state.fileSelector = state.fileSelector.concat(state.fileToUpload);
      }
    };
    const uploadAttachment = async id => {
      if (!state.fileSelector.length) return;
      const fileToUpload = state.fileSelector.filter(file => !file.expenseAttachmentId);
      if (!fileToUpload.length) return;
      const attachments = new FormData();
      fileToUpload.forEach(file => {
        attachments.append("attachments", file, file.fileName);
      });
      try {
        await axios({
          url: `/expenses/${id}/attachments`,
          method: "PUT",
          data: attachments,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } catch (error) {
        props.alerts.error("Unable to save attachment");
      }
    };
    const handelDeleteConfirmationModel = fileToDelete => {
      state.deleteExistingAttachmentClicked = true;
      state.attachmentToDelete = fileToDelete;
      confirmationDialog.value.open();
    };
    const clearAttachment = fileToRemove => {
      state.fileSelector = state.fileSelector.filter(file => file.id !== fileToRemove.id);
    };
    const handelDeleteAttachment = file => {
      if (!file.expenseAttachmentId) {
        clearAttachment(file);
        return;
      }
      state.expense.accounting ? handelDeleteConfirmationModel(file) : deleteExistingAttachment(file);
    };
    const deleteExistingAttachment = async fileToRemove => {
      try {
        await axios({
          url: `/expenses/attachment?expenseAttachmentId=${fileToRemove.expenseAttachmentId}`,
          method: "DELETE"
        }).then(() => {
          state.fileSelector = this.fileSelector.filter(file => file.expenseAttachmentId !== fileToRemove.expenseAttachmentId);
          state.attachmentToDelete = {};
        });
      } catch (error) {
        props.alerts.error("Unable to delete attachment");
      }
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_file_input = _resolveComponent("v-file-input");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_chip = _resolveComponent("v-chip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "bg-white w-4/12 shadow-lg rounded-sm absolute top-10 right-1/4",
        onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"])),
        style: {
          "width": "700px",
          "height": "auto",
          "max-width": "100%"
        }
      }, [state.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Unassigned Expense',
        class: "my-16 px-6"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_v_dialog, {
        modelValue: state.showAttachmentPreview,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.showAttachmentPreview = $event),
        width: "800"
      }, {
        default: _withCtx(() => [_createVNode(MultipleAttachmentPreview, {
          previewSource: state.fileSelector,
          onCancel: _cache[0] || (_cache[0] = $event => state.showAttachmentPreview = false),
          selectedFileIndex: state.selectedFileIndex
        }, null, 8, ["previewSource", "selectedFileIndex"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(LlConfirmationDialog, {
        ref_key: "confirmationDialog",
        ref: confirmationDialog,
        persistent: "",
        "show-warning-icon": "",
        "confirm-color": "error",
        message: "Deleting, replacing, or adding an attachment to this expense will not alter the attachment(s) associated with the expense in QuickBooks.",
        "toggle-text": "Cancel",
        "confirm-text": "OK",
        onConfirm: _cache[2] || (_cache[2] = $event => confirmDeleteAttachment()),
        onCancel: _cache[3] || (_cache[3] = $event => state.deleteExistingAttachmentClicked = false)
      }, null, 512), _createVNode(_component_v_dialog, {
        modelValue: state.showUploadModal,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => state.showUploadModal = $event),
        width: "700"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          title: "Upload Receipt"
        }, {
          append: _withCtx(() => [_createVNode(_component_v_icon, {
            onClick: _cache[4] || (_cache[4] = $event => state.showUploadModal = false)
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("mdi-close", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "bg-gray-100 text-center py-16",
              onDragover: _cache[7] || (_cache[7] = _withModifiers((...args) => _ctx.onDragOver && _ctx.onDragOver(...args), ["prevent"])),
              onDragleave: _cache[8] || (_cache[8] = _withModifiers((...args) => _ctx.onDragLeave && _ctx.onDragLeave(...args), ["prevent"])),
              onDrop: _withModifiers(onDrop, ["prevent"])
            }, [_createElementVNode("label", {
              onClick: _cache[5] || (_cache[5] = _withModifiers($event => triggerFileInput(), ["prevent"])),
              class: "text-lg font-medium"
            }, [...(_cache[27] || (_cache[27] = [_createTextVNode(" Drag and drop your receipt or ", -1), _createElementVNode("span", {
              class: "file-input-trigger"
            }, "Browse files", -1)]))]), _cache[28] || (_cache[28] = _createElementVNode("label", null, "PDF, JPG, and PNG files are allowed (Maximum size 20MB)", -1)), _createVNode(_component_v_file_input, {
              ref_key: "fileInput",
              ref: fileInput,
              accept: _unref(acceptedFileTypes).toString(),
              label: "Drag and drop files here or click to browse files",
              variant: "outlined",
              clearable: true,
              multiple: "",
              modelValue: state.fileToUpload,
              "onUpdate:modelValue": [_cache[6] || (_cache[6] = $event => state.fileToUpload = $event), selectAttachment],
              class: "hidden-file-input"
            }, null, 8, ["accept", "modelValue"])], 32)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(MainHeader, {
        content: state.hasMatter ? 'Edit Expense' : 'Assign Expense'
      }, null, 8, ["content"]), _withDirectives(_createElementVNode("div", _hoisted_4, [_cache[31] || (_cache[31] = _createElementVNode("span", {
        class: "btn btn-small dropdown-toggle",
        "data-toggle": "dropdown"
      }, [_createElementVNode("i", {
        class: "icon-cog"
      }), _createElementVNode("span", {
        class: "caret"
      })], -1)), _createElementVNode("ul", _hoisted_5, [_withDirectives(_createElementVNode("li", null, [_createElementVNode("span", {
        class: "menuitem",
        onClick: _cache[10] || (_cache[10] = _withModifiers($event => markAsBilled(), ["prevent"]))
      }, [...(_cache[29] || (_cache[29] = [_createElementVNode("i", {
        class: "fa fa-usd"
      }, null, -1), _createTextVNode("  Mark as Billed ", -1)]))])], 512), [[_vShow, state.expense.id && !state.expense.billed]]), _withDirectives(_createElementVNode("li", null, [_createElementVNode("span", {
        class: "menuitem",
        onClick: _cache[11] || (_cache[11] = _withModifiers($event => deleteExpense(), ["prevent"]))
      }, [...(_cache[30] || (_cache[30] = [_createElementVNode("i", {
        class: "fa fa-trash"
      }, null, -1), _createTextVNode("  Delete from LeanLaw ", -1)]))])], 512), [[_vShow, state.expense.id && !state.expense.billed]])])], 512), [[_vShow, !state.readonly]])]), _createElementVNode("div", _hoisted_6, [_cache[33] || (_cache[33] = _createElementVNode("div", {
        class: "w-8/12 pr-2 text-base"
      }, " This is from QuickBooks and the date and amounts must edited there if necessary. ", -1)), state.me.access.billing ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(LlSecondaryButton, {
        onClick: _cache[12] || (_cache[12] = _withModifiers($event => quickbooks(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createElementVNode("img", {
          src: "/img/qb16x16.png",
          alt: "",
          class: "mr-2"
        }, null, -1), _createTextVNode(" Open in QuickBooks ", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createVNode(ClientMatterSearch, {
        cm: state.cm,
        "query-filter": state.cmQueryFilter,
        horizontal: true
      }, null, 8, ["cm", "query-filter"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[34] || (_cache[34] = _createElementVNode("label", {
        class: "text-base"
      }, "Date", -1)), _createVNode(LlTextField, {
        density: "compact",
        disabled: true,
        variant: "outlined",
        "model-value": _ctx.formatDate(state.expense.date),
        "append-inner-icon": "mdi-calendar-month-outline"
      }, null, 8, ["model-value"])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("label", _hoisted_12, [_cache[36] || (_cache[36] = _createTextVNode("User", -1)), _withDirectives(_createVNode(LlTooltip, {
        icon: "help",
        class: "pl-2"
      }, {
        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("Optional: Can be set if expense is tied to a specific user ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !state.requireExpenseUser]])]), _createVNode(_component_v_autocomplete, {
        modelValue: state.expense.account,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => state.expense.account = $event),
        items: state.accounts,
        "item-title": "name",
        "item-value": "id",
        "return-object": "",
        clearable: "",
        density: "compact",
        variant: "outlined",
        class: "remove-outline",
        placeholder: state.requireExpenseUser ? 'No User' : 'No User (optional)'
      }, null, 8, ["modelValue", "items", "placeholder"])])]), _createElementVNode("div", _hoisted_13, [_cache[37] || (_cache[37] = _createElementVNode("label", {
        class: "text-base"
      }, "Invoice Description", -1)), _createVNode(_component_v_textarea, {
        modelValue: state.expense.description,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => state.expense.description = $event),
        rows: "3",
        id: "expense-description",
        variant: "outlined",
        onChange: _cache[15] || (_cache[15] = _withModifiers($event => state.okToClearDescription = false, ["prevent"])),
        disabled: state.readonly
      }, null, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[38] || (_cache[38] = _createElementVNode("label", {
        class: "text-base"
      }, "Amount", -1)), _createVNode(LlTextField, {
        density: "compact",
        disabled: true,
        modelValue: state.expense.amount,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => state.expense.amount = $event),
        variant: "outlined",
        prefix: "$"
      }, null, 8, ["modelValue"])]), state.expense?.client?.codes?.ledes && state.codes ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[39] || (_cache[39] = _createElementVNode("label", {
        class: "text-base"
      }, "Expense Code", -1)), _createVNode(_component_v_autocomplete, {
        modelValue: state.expense.code,
        "onUpdate:modelValue": [_cache[17] || (_cache[17] = $event => state.expense.code = $event), _cache[18] || (_cache[18] = $event => checkDescription(state.expense.code))],
        items: state.codes,
        "item-title": "label",
        "item-value": "id",
        "return-object": "",
        clearable: "",
        density: "compact",
        variant: "outlined",
        class: "remove-outline",
        placeholder: state.requireExpenseUser ? 'No User' : 'No User (optional)',
        "item-props": item => ({
          disabled: item.disabled
        })
      }, null, 8, ["modelValue", "items", "placeholder", "item-props"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_cache[40] || (_cache[40] = _createElementVNode("label", {
        class: "text-base"
      }, "Type", -1)), _createVNode(LlTextField, {
        class: "",
        type: "number",
        density: "compact",
        disabled: true,
        "model-value": state.expense?.accounting?.type == 'Purchase' ? 'Expense' : 'Bill',
        variant: "outlined"
      }, null, 8, ["model-value"])]), _withDirectives(_createElementVNode("div", null, [_cache[41] || (_cache[41] = _createElementVNode("label", {
        class: "text-base"
      }, " ", -1)), _createVNode(LlCheckbox, {
        modelValue: state.expense.customFlag,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => state.expense.customFlag = $event),
        label: state.me.company?.settings?.labels?.customFlag,
        "label-class": "text-base",
        disabled: state.readonly || state.saving,
        onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
      }, null, 8, ["modelValue", "label", "disabled"])], 512), [[_vShow, state.me.company?.settings?.labels?.customFlag]])]), _withDirectives(_createElementVNode("div", _hoisted_18, [...(_cache[42] || (_cache[42] = [_createElementVNode("label", null, " Attachments ", -1)]))], 512), [[_vShow, state.me.features.expenseAttachments]]), _withDirectives(_createElementVNode("div", _hoisted_19, [_createVNode(_component_v_icon, {
        class: "mr-2",
        color: "warning"
      }, {
        default: _withCtx(() => [...(_cache[43] || (_cache[43] = [_createTextVNode("mdi-alert", -1)]))]),
        _: 1
      }), _cache[44] || (_cache[44] = _createTextVNode(" This expense was part of a multi-line item in QuickBooks, and attachment syncing is not supported. ", -1))], 512), [[_vShow, state.expense.isMultiLineExpenseItem && state.me.company?.settings?.expenses?.syncAttachments]]), _withDirectives(_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", null, [_withDirectives(_createVNode(LlSecondaryButton, {
        "prepend-icon": "mdi-paperclip",
        onClick: _cache[21] || (_cache[21] = $event => state.showUploadModal = true)
      }, {
        default: _withCtx(() => [...(_cache[45] || (_cache[45] = [_createTextVNode(" Add Attachments ", -1)]))]),
        _: 1
      }, 512), [[_vShow, state.me.permissions?.expenses?.create]])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.fileSelector, (file, id) => {
        return _openBlock(), _createElementBlock("div", {
          key: id
        }, [_createElementVNode("div", _hoisted_22, [_withDirectives(_createVNode(_component_v_chip, {
          size: "large",
          variant: "outlined",
          "close-icon": "mdi-delete",
          label: ""
        }, {
          append: _withCtx(() => [_createVNode(_component_v_icon, {
            class: "mx-2",
            onClick: $event => handelDeleteAttachment(file)
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createTextVNode(" mdi-window-close ", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          prepend: _withCtx(() => [_withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [[_vShow, file.isQuickBooksAttachment]])]),
          default: _withCtx(() => [_createElementVNode("span", {
            class: "ml-2",
            onClick: $event => {
              state.showAttachmentPreview = true;
              state.selectedFileIndex = id;
            }
          }, _toDisplayString(_unref(truncateFileName)(file.name)), 9, _hoisted_24)]),
          _: 2
        }, 1536), [[_vShow, state.me.permissions?.expenses?.create]])])]);
      }), 128))])], 512), [[_vShow, state.me.features.expenseAttachments]]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_withDirectives(_createVNode(LlSecondaryButton, {
        id: "delete-expense-button",
        color: "error",
        class: "mr-2",
        onClick: _cache[22] || (_cache[22] = $event => deleteExpense())
      }, {
        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [_createElementVNode("span", {
          class: "fa fa-trash mr-2"
        }, null, -1), _createTextVNode("Delete from LeanLaw ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !state.readonly]])]), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        onClick: _cache[23] || (_cache[23] = $event => back(false))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(state.readonly ? "Done" : "Cancel"), 1)]),
        _: 1
      })])]), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        type: "submit",
        id: "save-expense-button",
        color: "primary",
        onClick: _cache[24] || (_cache[24] = _withModifiers($event => save(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [_createTextVNode(" Save ", -1)]))]),
        _: 1
      })])])])]))])]);
    };
  }
};